import type { NotificationDatabaseAsyncDelete } from "@/entities/notification-database";

export const getTitleTranslationKey = (
  notification: NotificationDatabaseAsyncDelete
): string => {
  const { is_batch_processing, models } = notification.data;

  const modelType = models[0].type;
  const item = is_batch_processing ? `${modelType}s` : modelType;

  return `notification:asyncDelete.title.${item}`;
};
